var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#4465ff",
    width: "1em",
    height: "1em",
    viewBox: "0 0 10.18 7.89"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ArrowIcon_svg__arrow{stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ArrowIcon_svg__arrow",
    d: "M.5 3.948h9.175M6.442.707L9.68 3.945 6.442 7.183"
  })));
}
export default __webpack_public_path__ + "81512fcf251bf45ac0a5ad38b01e8224.svg";
export { SvgArrowIcon as ReactComponent };